import React, { useState } from 'react';
import { Sparkles, Mail, Send, CheckCircle2, ChevronRight, Headphones, ShieldCheck, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { slugify } from '../../utils/formatters';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setIsSubmitted(true);
      setEmail('');
    }, 1000);
  };

  return (
    <footer id="cupon-section" className="bg-slate-950 text-slate-400 border-t border-slate-900 text-xs relative overflow-hidden pt-16 pb-12">
      
      {/* Hiệu ứng ánh sáng nền trang trí mờ ảo */}
      <div className="absolute top-0 left-1/3 w-96 h-96 bg-indigo-600/10 rounded-full blur-3xl pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-12 gap-10 pb-12 border-b border-slate-900">
        
        {/* Cột 1: Thông tin thương hiệu (Chiếm 4 cột) */}
        <div className="space-y-4 md:col-span-4">
          <div className="flex items-center space-x-2">
            <Sparkles className="w-5 h-5 text-indigo-400" />
            <span className="text-xl font-bold text-white font-serif tracking-tight">
              Japan<span className="text-indigo-500">ICHIBA</span>
            </span>
          </div>
          <p className="text-slate-400 leading-relaxed text-xs sm:text-sm">
            Thương hiệu phân phối các sản phẩm thời trang và công nghệ cao cấp hàng đầu Việt Nam, mang tinh hoa xứ sở hoa anh đào đến gần bạn hơn.
          </p>
          <div className="pt-2 text-slate-500 text-[11px] space-y-1">
            <p className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5 text-indigo-400" /> Tokyo, Japan & Hà Nội, Việt Nam</p>
            <p className="flex items-center gap-1.5"><Headphones className="w-3.5 h-3.5 text-indigo-400" /> Hỗ trợ 24/7: 1900 xxxx</p>
          </div>
        </div>

        {/* Cột 2: Danh Mục (Chiếm 2 cột) */}
        <div className="md:col-span-2 space-y-3">
          <h5 className="text-white font-bold uppercase tracking-wider text-[11px] border-l-2 border-indigo-500 pl-2">Danh Mục</h5>
          <ul className="space-y-2.5">
            <li><Link to={`/category/${slugify('Máy tính và đồ dùng văn phòng')}`} className="hover:text-white hover:translate-x-1 transition-all duration-200 block">Máy tính,đồ dùng văn phòng</Link></li>
            <li><Link to={`/category/${slugify('Quần áo, giày dép, túi xách, đồng hồ')}`} className="hover:text-white hover:translate-x-1 transition-all duration-200 block">Thời trang & phụ kiện</Link></li>
            <li><Link to={`/category/${slugify('Mỹ phẩm, thuốc')}`} className="hover:text-white hover:translate-x-1 transition-all duration-200 block">Mỹ phẩm,thuốc</Link></li>
            <li><Link to={`/category/${slugify('Thể thao & hoạt động ngoài trời')}`} className="hover:text-white hover:translate-x-1 transition-all duration-200 block">Thể thao </Link></li>
          </ul>
        </div>

        {/* Cột 3: Hỗ Trợ Khách Hàng (Chiếm 2 cột) */}
        <div className="md:col-span-2 space-y-3">
          <h5 className="text-white font-bold uppercase tracking-wider text-[11px] border-l-2 border-indigo-500 pl-2">Hỗ Trợ</h5>
          <ul className="space-y-2.5">
            <li><Link to="/support/bao-hanh" className="hover:text-white hover:translate-x-1 transition-all duration-200 block">Chính Sách Bảo Hành</Link></li>
            <li><Link to="/support/doi-tra" className="hover:text-white hover:translate-x-1 transition-all duration-200 block">Chính Sách Đổi Trả</Link></li>
            <li><Link to="/support/chon-size" className="hover:text-white hover:translate-x-1 transition-all duration-200 block">Hướng Dẫn Chọn Size</Link></li>
            <li><Link to="/support/faqs" className="hover:text-white hover:translate-x-1 transition-all duration-200 block">Câu Hỏi Thường Gặp</Link></li>
          </ul>
        </div>

        {/* Cột 4: Đăng Ký Nhận Ưu Đãi (Chiếm 4 cột - Thiết kế dạng Box nổi bật) */}
        <div className="md:col-span-4 bg-gradient-to-br from-slate-900 to-slate-900/90 border border-slate-800 rounded-3xl p-6 shadow-2xl relative backdrop-blur-md">
          <div className="flex items-center space-x-2 text-indigo-400 mb-2">
            <Mail className="w-4 h-4" />
            <h5 className="text-white font-bold uppercase tracking-wider text-[11px]">Nhận Voucher Giảm 10%</h5>
          </div>
          <p className="text-slate-400 text-xs mb-4 leading-relaxed">
            Đăng ký email ngay hôm nay để không bỏ lỡ các bộ sưu tập giới hạn và mã giảm giá độc quyền.
          </p>

          {isSubmitted ? (
            <div className="bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 rounded-2xl p-4 flex items-center space-x-3 animate-in fade-in duration-300">
              <CheckCircle2 className="w-5 h-5 shrink-0 text-emerald-400" />
              <div>
                <p className="font-bold text-xs">Đăng ký thành công!</p>
                <p className="text-[11px] text-emerald-400/80 mt-0.5">Voucher 10% đã được gửi qua email.</p>
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubscribe} className="space-y-3">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Nhập địa chỉ email của bạn..."
                required
                className="bg-slate-950 border border-slate-800 rounded-2xl px-4 py-3 text-white placeholder-slate-600 w-full focus:outline-none focus:border-indigo-500 transition text-xs shadow-inner"
              />
              <button
                type="submit"
                disabled={isLoading}
                className="w-full bg-indigo-600 hover:bg-indigo-500 active:scale-[0.98] text-white font-bold px-4 py-3 rounded-2xl transition flex items-center justify-center space-x-2 shadow-lg shadow-indigo-600/30 cursor-pointer disabled:opacity-50"
              >
                {isLoading ? (
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                ) : (
                  <>
                    <span>Đăng Ký Nhận Mã</span>
                    <Send className="w-3.5 h-3.5" />
                  </>
                )}
              </button>
            </form>
          )}
        </div>

      </div>

      {/* Dòng bản quyền */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8 flex flex-col sm:flex-row items-center justify-between text-slate-500 text-xs gap-4">
        <p>© 2026 JapanICHIBA. Tất cả quyền được bảo lưu.</p>
        <div className="flex items-center space-x-6 text-[11px]">
          <Link to="/support/bao-hanh" className="hover:text-white transition">Chính sách bảo mật</Link>
          <Link to="/support/doi-tra" className="hover:text-white transition">Điều khoản sử dụng</Link>
        </div>
      </div>
    </footer>
  );
}